export default class {
  constructor() {
    this.$modals = $('div[id^="popup"]');
  }

  init() {
    if(![...this.$modals].length) {
      return;
    }

    $(() => {
      const vm = this;
      import('js-cookie').then(module => {
        const Cookies = module.default;
        [...this.$modals].forEach((item) => {
          const $el = $(item);
          const cookieKey = $el.data('cookie');
          const delay = $el.data('delay');
          const expires = $el.data('expiry');

          if (window.OTMT.debug === 'true') {
            Cookies.remove(cookieKey, { path: '' });
          }

          if (Cookies.get(cookieKey)) {
            return;
          }

          document.addEventListener('mouseleave', () => {
            if (!Cookies.get(cookieKey)) {
              this.constructor.openModal($el);
            }
          }, false);

          if ($el.closest('.tab-pane:not(.active)').length) {
            $('a[data-toggle="tab"]').on('click', () => {
              if ($el.closest('.tab-pane.active').length) {
                setTimeout(() => {
                  if (!Cookies.get(cookieKey)) {
                    this.constructor.openModal($el);
                  }
                }, delay * 1000);
              }
            });
          }

          if (!$el.closest('.tab-pane').length) {
            setTimeout(() => {
              if (!Cookies.get(cookieKey)) {
                this.constructor.openModal($el);
              }
            }, delay * 1000);
          }

          $el.find('.popup-close').on({
            click(e) {
              e.preventDefault();
              Cookies.set(cookieKey, true, { expires, path: '' });
              vm.constructor.closeModal($el);
            },
          });
        });
      });
    });
  }

  static openModal(modal) {
    const $body = $('body');
    if (modal.hasClass('hidden')) {
      modal.removeClass('hidden').addClass('opening');
      setTimeout(() => {
        modal.removeClass('opening').addClass('open');
        $body.addClass('modal-open');
      }, 50);
    }
  }

  static closeModal(modal) {
    const $body = $('body');
    if (modal.hasClass('open')) {
      modal.removeClass('open').addClass('hiding');
      setTimeout(() => {
        modal.removeClass('hiding').addClass('hidden');
        $body.removeClass('modal-open');
      }, 500);
    }
  }
}
